(function () {
  class MessageBox extends PIXI.Container {
    constructor() {
      super();

      this._messageText = undefined;
    }

    initialise() {
      const self = this;
      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._messageText = resourceManager.get('slotContainer:messageBar:messageTextContainer:messageText');
      this.visible = false;
    }

    show(visible, duration = 0.5, justFade = false) {
      if (visible) {
        this.visible = true;
        if (duration > 0) {
          gsap.fromTo(
            this,
            { pixi: { scale: justFade ? 1 : 0, alpha: 0 } },
            {
              pixi: { scale: 1, alpha: 1 },
              duration: duration,
              ease: justFade ? 'none' : 'power1.out',
            }
          );
        } else {
          this.alpha = 1;
          this.scale.set(1);
        }
      } else {
        if (duration > 0) {
          gsap.fromTo(
            this,
            { pixi: { scale: 1, alpha: 1 } },
            {
              pixi: { scale: justFade ? 1 : 0, alpha: 0 },
              ease: justFade ? 'none' : 'back.in',
              duration: duration,
              onComplete: () => {
                this.clearMessage();
                this.visible = false;
              },
            }
          );
        } else {
          this.alpha = 0;
          this.scale.set(0);
          this.clearMessage();
          this.visible = false;
        }
      }
    }

    setValue = function (value) {
      this._messageText.setText(value);
    };

    setMessage = function (text, translationParams, value, symbolIndex) {
      var args = [];
      if (checkForDefined(translationParams)) {
        for (var i = 1; i < arguments.length; i++) {
          args.push(arguments[i]);
        }
      }
      this._messageText.setTranslationPhrase(text);
      this._messageText.setTranslationParameters.apply(this._messageText, args);
    };

    clearMessage = function () {
      this._messageText.setText('');
    };
  }

  let create = function (json) {
    return new MessageBox();
  };

  let initialise = function (json, messageBox) {
    messageBox.initialise();
  };

  let getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('messageBox', create, initialise, getFilesRequired);
})();
